import { render, staticRenderFns } from "./cr_img_gallery.vue?vue&type=template&id=39fabaee&"
import script from "./cr_img_gallery.vue?vue&type=script&lang=js&"
export * from "./cr_img_gallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39fabaee')) {
      api.createRecord('39fabaee', component.options)
    } else {
      api.reload('39fabaee', component.options)
    }
    module.hot.accept("./cr_img_gallery.vue?vue&type=template&id=39fabaee&", function () {
      api.rerender('39fabaee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/crud/cr_img_gallery.vue"
export default component.exports